import store from "../store";
import { cookie } from "./index";
import analytics from "./analytics";
import axios from "axios";

export default {
	getUser() {
		return localStorage.user ? JSON.parse(localStorage.user) : null;
	},
	setUser(user) {
		localStorage.user = JSON.stringify(user);
	},
	getBalance() {
		return localStorage.user ? JSON.parse(localStorage.user).balance : null;
	},
	getAuthStatus() {
		return localStorage.authenticated
			? JSON.parse(localStorage.authenticated)
			: false;
	},
	setAuthStatus(status) {
		localStorage.authenticated = status;
	},
	getToken() {
		return localStorage.token ? JSON.parse(localStorage.token) : null;
	},
	logout() {
		const payload = {
			profile_id: store.getters.user.id,
			user_alternative_id: store.getters.user.id,
			mobile: store.getters.user.mobile,
			app_name: "MOBILE_WEB",
			wallet_balance: store.getters.user.balance,
			wallet_currency: CURRENCY,
			points_balance: store.getters.user.points,
			bonus_balance: store.getters.user.bonus,
		};

		//delete affiliate token
		if (cookie.get("aff_token")) {
			cookie.delete("aff_token");
		}

		store.commit("logout");

		// Update GrowthBook user attributes for logged out user
		try {
			store.dispatch('growthbook/updateUserAttributes', null)
		} catch (e) {
			console.error('Failed to update GrowthBook user attributes on logout:', e)
		}
	},
	updateUserSettings() {
		store.commit("updateUserSettings", null);
		return;
	},
	validatePhoneNumber(phone) {
		const regex = new RegExp(MOBILE_REGEX);
		return regex.test(phone);
	},
	register(payload) {
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;

		return new Promise((resolve, reject) => {
			// Validate payload
			if (!this.validatePhoneNumber(payload.mobile)) {
				reject({
					type: "phone",
					message: app.$i18n.t("session.please-input-a-valid-phone-number"),
					status: 0,
				});
			}
			if (!payload.password) {
				reject({
					type: "password",
					message: app.$i18n.t("session.please-input-a-password"),
					status: 0,
				});
			}

			payload.mobile = payload.mobile.split(" ").join("").toString();
			payload.src = "MOBILE_WEB";

			if (cookie.get("aff_token")) {
				payload.affiliate_id = AFFILIATES_ID;
				payload.affiliate_tag = cookie.get("aff_token");
			}
			if (cookie.get("share_code"))
				payload.share_code = cookie.get("share_code");

			// analyticsPlugin.registration.attempt({
			// 	mobile: payload.affiliate_id,
			// 	affiliateId: payload.affiliate_id,
			// 	affiliateId: payload.affiliate_id,
			// 	affiliateTag: payload.affiliate_tag,
			// 	shareCode: payload.share_code,
			// 	mobile: payload.mobile,
			// });
			axios
				.post(`${BASE_URL}newsignup`, payload)
				.then((response) => {
					localStorage.last_successful_phone_number = payload.mobile;
					// Track registration
					// analytics.registration.success({
					// 	mobile: payload.mobile,
					// 	message: response.data.success.message,
					// 	user_id: response.data.success.profile_id,
					// });

					//delete affiliate token
					cookie.delete("aff_token");

					resolve(response.data);
				})
				.catch((error) => {
					if (!error.response) {
						// analytics.registration.failed({
						// 	affiliateId: payload.affiliate_id,
						// 	affiliateTag: payload.affiliate_tag,
						// 	shareCode: payload.share_code,
						// 	mobile: payload.mobile,
						// 	message: error.message,
						// });
						reject({
							type: "global",
							message: app.$i18n.t("session.an-error-occured-please-try-again"),
							status: 1,
						});
					}
					// analytics.registration.failed({
					// 	affiliateId: payload.affiliate_id,
					// 	affiliateTag: payload.affiliate_tag,
					// 	shareCode: payload.share_code,
					// 	mobile: payload.mobile,
					// 	message: error.response
					// 		? error.response.data.error.message
					// 		: error.message,
					// });
					reject({
						type: "global",
						message: error.response.data.error.message,
						status: error.response.status,
					});
				});
		});
	},
	addKyc(payload) {
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;

		return new Promise((resolve, reject) => {
			payload.src = "MOBILE_WEB";

			if (cookie.get("share_code"))
				payload.share_code = cookie.get("share_code");

			// analytics.kyc.attempt({
			// 	affiliateId: payload.affiliate_id,
			// 	affiliateTag: payload.affiliate_tag,
			// 	shareCode: payload.share_code,
			// 	mobile: payload.mobile,
			// });
			axios
				.post(`${BASE_URL}add-kyc`, payload)
				.then((response) => {
					localStorage.last_successful_phone_number = payload.mobile;

					store.commit("setKyc", true);
					// Track registration
					// analytics.kyc.success({
					// 	mobile: payload.mobile,
					// 	message: response.message,
					// });
					resolve(response.data);
				})
				.catch((error) => {
					if (!error.response) {
						// analytics.kyc.failed({
						// 	affiliateId: payload.affiliate_id,
						// 	affiliateTag: payload.affiliate_tag,
						// 	shareCode: payload.share_code,
						// 	mobile: payload.mobile,
						// 	message: app.$i18n.t("session.an-error-occured-please-try-again"),
						// });
						reject({
							type: "global",
							message: app.$i18n.t("session.an-error-occured-please-try-again"),
							status: 1,
						});
					}
					// analytics.kyc.failed({
					// 	affiliateId: payload.affiliate_id,
					// 	affiliateTag: payload.affiliate_tag,
					// 	shareCode: payload.share_code,
					// 	mobile: payload.mobile,
					// 	message: error.response.data.message,
					// });
					reject({
						type: "global",
						message: error.response.data.message,
						status: error.response.data.status,
					});
				});
		});
	},
	verifyKyc(payload) {
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;
		return new Promise((resolve, reject) => {
			axios
				.post(`${BASE_URL}verify-kyc`, payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error.response.data);
				});
		});
	},
	sendCode(payload) {
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;
		return new Promise((resolve, reject) => {
			// Validate payload
			if (!this.validatePhoneNumber(payload.mobile)) {
				reject({
					type: "phone",
					message: app.$i18n.t("session.please-input-a-valid-phone-number"),
					status: 0,
				});
			}

			payload.mobile = payload.mobile.split(" ").join("").toString();

			console.log(
				"Accessing translater",
				app.$i18n.t("session.please-check-your-messages-for-the-betika-code")
			);

			axios
				.post(`${BASE_URL}code`, payload)
				.then((response) => {
					localStorage.last_successful_phone_number = payload.mobile;
					resolve(
						//response.data.success.message +
						//`. Please check your messages for the Betika Code or Dial ${USSD_VERIFICATION_CODE_NUMBER}`
						response.data.success.message +
							`. ` +
							app.$i18n.t(
								"session.please-check-your-messages-for-the-betika-code"
							)
					);
				})
				.catch((error) => {
					if (!error.response) {
						reject({
							type: "global",
							message: app.$i18n.t("session.an-error-occured-please-try-again"),
							status: 1,
						});
					}
					reject({
						type: "global",
						message: error.response.data.error.message,
						status: error.response.status,
					});
				});
		});
	},
	login(data) {
		let vm = this;
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;

		return new Promise((resolve, reject) => {
			let allowedPrefixes = ["2547", "2541", "07", "01", "7", "1"];
			let regex = new RegExp(`(${allowedPrefixes.join("|")})` + "(\\d){8}");

			// Test phone number
			if (data.phone.length === 0) {
				reject({
					type: "phone",
					message: app.$i18n.t("session.please-enter-phone-no"),
				});
			}

			data.phone = data.phone.replace(" ", "");

			if (!regex.test(data.phone)) {
				reject({
					type: "phone",
					message: app.$i18n.t("session.this-phone-no-is-invalid"),
				});
			}

			// Test password
			if (data.password.length == 0) {
				reject({
					type: "password",
					message: app.$i18n.t("session.please-enter-password"),
				});
			}

			let payload = {
				mobile: data.phone,
				password: data.password,
				remember: data.remember,
				src: "MOBILE_WEB",
			};

			// Check if from MyAffiliates
			if (cookie.get("aff_token")) {
				payload.affiliate_id = AFFILIATES_ID;
				payload.affiliate_tag = cookie.get("aff_token");
			}

			// Check if from a shared betslip
			if (cookie.get("login_share_code"))
				payload.share_code = cookie.get("login_share_code");

			// analytics.login.attempt({
			// 	mobile: payload.mobile,
			// 	remember: payload.remember,
			// });

			axios
				.post(`${BASE_URL}login`, payload)
				.then((response) => {
					const token = response.data.token.replace(/['"]+/g, "");
					const user = response.data.data.user;

					window.localStorage.setItem("authenticated", true);
					window.localStorage.setItem("token", JSON.stringify(token));
					window.localStorage.setItem("user", JSON.stringify(user));
					store.commit("setUser", user);
					store.commit("setToken", token);
					store.commit("setAuthenticated", true);

					//store myAffilliates token to storage
					store.commit(
						"affiliates/SET_AFFILIATE_ID",
						response.data.data.affiliate_id
					);
					store.commit(
						"affiliates/SET_AFFILIATE_TAG",
						response.data.data.affiliate_tag
					);

					// analytics.login.success({
					// 	mobile: payload.mobile,
					// 	user_id: response.data.data.user.id,
					// 	wallet_balance: response.data.data.user.balance,
					// 	points_balance: response.data.data.user.points,
					// 	bonus_balance: response.data.data.user.bonus,
					// });

					vm.updateUserSettings();

					try {
						if (!store.getters['growthbook/isGrowthBookInitialized']) {
							store.dispatch('growthbook/initializeGrowthBook')
								.then(() => {
									// Update user attributes in GrowthBook
									store.dispatch('growthbook/updateUserAttributes', user)
								})
								.catch(e => {
									console.error('Failed to initialize GrowthBook:', e)
								})
						} else {
							// Update user attributes in GrowthBook
							store.dispatch('growthbook/updateUserAttributes', user)
						}
					} catch (e) {
						console.error('Failed to initialize GrowthBook:', e)
					}

					try {
						// Run all actions that required authentication to run
						store.getters.authActions.forEach((action) => {
							action();
						});
					} catch (e) {
						console.error(e);
					}

					//delete affiliate token
					cookie.delete("aff_token");

					resolve(true);
				})
				.catch((error) => {
					if (!error.response) {
						// Network/Syntax/Device error
						// analytics.login.failed({
						// 	mobile: payload.mobile,
						// 	message: error.message,
						// });

						reject({
							type: "error",
							message: app.$i18n.t("session.an-error-occured-please-try-again"),
						});
					}

					// Normal error
					// analytics.login.failed({
					// 	mobile: payload.mobile,
					// 	message: error.response.data.error.message,
					// });
					reject({
						type: "error",
						message: error.response.data.error.message,
					});
				});
		});
	},
	setAuthData(data) {
		let vm = this;
		//TODO: Mazingaombwe done here for translation
		const app = window.betika;

		try {
			const token = data.token;
			const user = data.user;

			window.localStorage.setItem("authenticated", true);
			window.localStorage.setItem("token", JSON.stringify(token));
			window.localStorage.setItem("user", JSON.stringify(user));
			store.commit("setUser", user);
			store.commit("setToken", token);
			store.commit("setAuthenticated", true);
			// analytics.login.success({
			// 	mobile: data.mobile,
			// 	user_id: data.user.id,
			// 	wallet_balance: data.user.balance,
			// 	points_balance: data.user.points,
			// 	bonus_balance: data.user.bonus,
			// });

			vm.updateUserSettings();

			// Run all actions that required authentication to run
			store.getters.authActions.forEach((action) => {
				action();
			});
		} catch (e) {
			console.error(e);
			return false;
		}
		return true;
	},
};
